import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useConnectedWalletCapability } from '../connected-wallet/connected-wallet-react.js';
import { useCryptoDepositCapability } from '../crypto-deposit/crypto-deposit-react.js';
import { useConnectedExchanges } from '../exchange/exchange-react.js';
import { withdrawalContextQuery } from '../offramp/context-query.js';
import { accountAvailableMethods, accountUnavailableMethods } from './available-methods.js';
export function useAccountAvailableMethods(options) {
  const $ = _c(38);
  const [direction, setDirection] = useState("onramp");
  const enabled = options.enabled && options.masterEnabled;
  const wallet = useConnectedWalletCapability(options.client, options.surface, enabled && direction === "onramp");
  const crypto = useCryptoDepositCapability(options.client, options.surface, enabled && direction === "onramp");
  const exchanges = useConnectedExchanges(options.client, options.surface, enabled && direction === "onramp");
  let t0;
  if ($[0] !== options.client || $[1] !== options.currency || $[2] !== options.surface) {
    t0 = withdrawalContextQuery(options.client, options.currency, options.surface);
    $[0] = options.client;
    $[1] = options.currency;
    $[2] = options.surface;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const t1 = enabled && direction === "offramp";
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      ...t0,
      enabled: t1,
      retry: false,
      refetchOnWindowFocus: false
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const withdrawal = useQuery(t2);
  const error = direction === "offramp" ? withdrawal.isError : wallet.isError || crypto.isError || exchanges.isError;
  let t3;
  let t4;
  if ($[7] !== error || $[8] !== options.client) {
    t3 = () => {
      if (error) {
        options.client.observeFunnel?.({
          stage: "profile",
          outcome: "error",
          errorCode: "onramp_refresh_failed"
        });
      }
    };
    t4 = [options.client, error];
    $[7] = error;
    $[8] = options.client;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  const t5 = wallet.data === true;
  const t6 = crypto.data === true;
  let t7;
  if ($[11] !== direction || $[12] !== exchanges.data || $[13] !== options || $[14] !== t5 || $[15] !== t6 || $[16] !== withdrawal.data) {
    t7 = accountAvailableMethods({
      ...options,
      direction,
      withdrawal: withdrawal.data,
      connectedWallet: t5,
      cryptoDeposit: t6,
      exchanges: exchanges.data ?? []
    });
    $[11] = direction;
    $[12] = exchanges.data;
    $[13] = options;
    $[14] = t5;
    $[15] = t6;
    $[16] = withdrawal.data;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = wallet.data === true;
  const t9 = crypto.data === true;
  let t10;
  if ($[18] !== direction || $[19] !== exchanges.data || $[20] !== options || $[21] !== t8 || $[22] !== t9 || $[23] !== withdrawal.data) {
    t10 = accountUnavailableMethods({
      ...options,
      direction,
      withdrawal: withdrawal.data,
      connectedWallet: t8,
      cryptoDeposit: t9,
      exchanges: exchanges.data ?? []
    });
    $[18] = direction;
    $[19] = exchanges.data;
    $[20] = options;
    $[21] = t8;
    $[22] = t9;
    $[23] = withdrawal.data;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const t11 = direction === "onramp" ? options.connection.quoteContext?.context.country : withdrawal.data?.country;
  const t12 = enabled && (direction === "offramp" ? withdrawal.isPending : wallet.isPending || crypto.isPending || exchanges.isPending);
  const t13 = direction === "offramp" ? withdrawal.isFetching : wallet.isFetching || crypto.isFetching || exchanges.isFetching;
  let t14;
  if ($[25] !== crypto || $[26] !== direction || $[27] !== enabled || $[28] !== error || $[29] !== exchanges || $[30] !== t10 || $[31] !== t11 || $[32] !== t12 || $[33] !== t13 || $[34] !== t7 || $[35] !== wallet || $[36] !== withdrawal) {
    t14 = {
      direction,
      methods: t7,
      unavailableMethods: t10,
      country: t11,
      loading: t12,
      error,
      refreshing: t13,
      async refresh() {
        if (!enabled) {
          return;
        }
        if (direction === "offramp") {
          await withdrawal.refetch({
            cancelRefetch: false
          });
        } else {
          await Promise.all([wallet.refetch({
            cancelRefetch: false
          }), crypto.refetch({
            cancelRefetch: false
          }), exchanges.refetch({
            cancelRefetch: false
          })]);
        }
      },
      setDirection
    };
    $[25] = crypto;
    $[26] = direction;
    $[27] = enabled;
    $[28] = error;
    $[29] = exchanges;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
    $[33] = t13;
    $[34] = t7;
    $[35] = wallet;
    $[36] = withdrawal;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  return t14;
}